var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecycleBin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6377 13.1915L36.1542 37.6732C36.0068 40.1044 33.9925 41.9999 31.5579 41.9999H16.0929C13.6583 41.9999 11.644 40.1044 11.4967 37.6732L10.0131 13.1915C9.99303 12.8466 10.1153 12.5084 10.353 12.2555C10.5908 12.0027 10.9207 11.8604 11.2673 11.8604H36.3835C36.7302 11.8604 37.06 12.0027 37.2978 12.2555C37.5355 12.5084 37.6578 12.8466 37.6377 13.1915ZM35.049 14.372H12.6018L14.0049 37.5225C14.0719 38.6259 14.9861 39.4883 16.0929 39.4883H31.5579C32.6647 39.4883 33.5789 38.6259 33.6459 37.5225L35.049 14.372Z",
    fill: "#D42124"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8953 11.8604C39.5886 11.8604 40.1512 12.423 40.1512 13.1162C40.1512 13.8094 39.5886 14.372 38.8953 14.372H8.75581C8.0626 14.372 7.5 13.8094 7.5 13.1162C7.5 12.423 8.0626 11.8604 8.75581 11.8604H38.8953Z",
    fill: "#D42124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5882 9.34047L32.5677 12.7713C32.6765 13.1498 32.5995 13.5583 32.3634 13.8731C32.1256 14.1879 31.7539 14.3721 31.3604 14.3721H16.2907C15.8972 14.3721 15.5255 14.1879 15.2877 13.8731C15.0516 13.5583 14.9746 13.1498 15.0834 12.7713L16.0629 9.34047C16.6289 7.36298 18.4356 6 20.4918 6H27.1593C29.2155 6 31.0222 7.36298 31.5882 9.34047ZM29.172 10.0303C28.9158 9.13116 28.0953 8.51163 27.1593 8.51163H20.4918C19.5558 8.51163 18.7353 9.13116 18.4791 10.0303L17.955 11.8605H29.6961L29.172 10.0303Z",
    fill: "#D42124"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5698 20.6513C22.5698 19.9581 23.1324 19.3955 23.8256 19.3955C24.5188 19.3955 25.0815 19.9581 25.0815 20.6513V32.3723C25.0815 33.0655 24.5188 33.6281 23.8256 33.6281C23.1324 33.6281 22.5698 33.0655 22.5698 32.3723V20.6513Z",
    fill: "#D42124"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9352 32.4709C30.8665 33.1607 30.2503 33.6647 29.5605 33.5961C28.8706 33.5274 28.3683 32.9113 28.4369 32.2214L29.604 20.5524C29.6727 19.8625 30.2888 19.3585 30.9787 19.4272C31.6686 19.4958 32.1726 20.112 32.1039 20.8019L30.9352 32.4709Z",
    fill: "#D42124"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2143 32.2214C19.2829 32.9113 18.7806 33.5274 18.0907 33.5961C17.4009 33.6647 16.7847 33.1607 16.716 32.4709L15.5473 20.8019C15.4786 20.112 15.9826 19.4958 16.6725 19.4272C17.3623 19.3585 17.9785 19.8625 18.0472 20.5524L19.2143 32.2214Z",
    fill: "#D42124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBin2);
export default __webpack_public_path__ + "static/media/recycle-bin2.977bff44538f09f59ba1a4ae8920d008.svg";
export { ForwardRef as ReactComponent };